import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';

/**
 * @deprecated this type is outdated and will be removed with v5.0.0
 */

/**
 * @deprecated this context is outdated and will be removed with v5.0.0
 */
export var BrandVolumeContext = /*#__PURE__*/React.createContext('regular');
/**
 * @deprecated this consumer is outdated and will be removed with v5.0.0
 */
export var BrandVolumeConsumer = BrandVolumeContext.Consumer;

/**
 * @deprecated this hook is outdated and will be removed with v5.0.0
 */
export var useBrandVolume = function useBrandVolume() {
  return React.useContext(BrandVolumeContext);
};
var getBrandVolumeFromProps = function getBrandVolumeFromProps(_ref) {
  var low = _ref.low,
    high = _ref.high;
  return low ? 'low' : high ? 'high' : 'regular';
};
var BrandVolumeProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BrandVolumeProvider, _React$PureComponent);
  var _super = _createSuper(BrandVolumeProvider);
  function BrandVolumeProvider() {
    _classCallCheck(this, BrandVolumeProvider);
    return _super.apply(this, arguments);
  }
  _createClass(BrandVolumeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        brandVolume: getBrandVolumeFromProps(this.props)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var brandVolume = getBrandVolumeFromProps(this.props);
      return /*#__PURE__*/React.createElement(BrandVolumeContext.Provider, {
        value: brandVolume
      }, this.props.children);
    }
  }]);
  return BrandVolumeProvider;
}(React.PureComponent); // @ts-expect-error
BrandVolumeProvider.displayName = 'BrandVolumeProvider';
// @ts-expect-error
BrandVolumeProvider.defaultProps = {
  low: false,
  high: false,
  regular: true
};
// @ts-expect-error
BrandVolumeProvider.childContextTypes = {
  brandVolume: PropTypes.oneOf(['low', 'regular', 'high'])
};

/**
 * @deprecated this provider is outdated and will be removed with v5.0.0
 */
export default BrandVolumeProvider;
//# sourceMappingURL=index.js.map